<template>
    <span class="d-inline-flex">
        <CancelButton
            key="cancel-button"
            :is-small="isSmall"
            as-link
            :disabled="disabled || isLoading"
            :hide-label="hideLabel"
            @click.prevent="handleCancel()" />

        <span>&nbsp;</span>

        <CreateButton
            v-if="isCreating"
            key="create-button"
            :type="type"
            :label="submitLabel"
            :is-small="isSmall"
            :is-loading="isLoading"
            :disabled="disabled || isLoading"
            :hide-label="hideLabel"
            @click="($event) => handleSave($event)" />

        <SaveButton
            v-else
            key="save-button"
            :type="type"
            :label="submitLabel"
            :is-small="isSmall"
            :is-loading="isLoading"
            :disabled="disabled || isLoading"
            :hide-label="hideLabel"
            @click="($event) => handleSave($event)" />
    </span>
</template>

<script>
import CancelButton from '@/js/components/common/buttons/CancelButton';
import CreateButton from '@/js/components/common/buttons/CreateButton';
import SaveButton from '@/js/components/common/buttons/SaveButton';

export default {
    name: 'FormActions',

    components: {CancelButton, CreateButton, SaveButton},

    props: {
        type: {type: String, default: 'button'},
        label: {type: String, default: null},
        isCreating: {type: Boolean},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        isLoading: {type: Boolean},
        disabled: {type: Boolean},
    },

    computed: {
        submitLabel() {
            if (this.label) {
                return this.label;
            }

            if (this.isCreating) {
                return this.$t('common.actions.create');
            }

            return this.$t('common.actions.save');
        },
    },

    methods: {
        handleSave(event) {
            if (this.type === 'submit') {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            this.$emit('save');
        },

        handleCancel() {
            this.$emit('cancel');
        },
    },
};
</script>
